import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderRadioField, renderSelectField, renderTextField } from '../../../Forms/fieldRenderers'
import { FormControlLabel, Switch, Button, IconButton, makeStyles, Tooltip } from '@material-ui/core'
import CallesDeBruto from './CallesDeBruto'
import { COLORES } from '../../../../config/colores'
import InfoIcon from '@material-ui/icons/Info'
import { EstadoCerealParaPedido } from './EstadoCerealParaPedido'

const useStyles = makeStyles(() => ({
  container: {
    borderRadius: '12px',
    padding: '12px',
    backgroundColor: '#dfdfdf',
    width: '90%',
    margin: 'auto'
  },
  contenidoCenter: {
    display: 'flex',
    alignItems: 'center'
  }
}))

function CamposPedidoCamiones (props) {
  const { cerealesActivos, calificaciones, handleSubmit, max, formChange } = props
  const [isSiloAparte, setIsSiloAparte] = useState(false)
  const [calificacionSeleccionada, setCalificacionSeleccionada] = useState(null)
  const [cerealSeleccionado, setCerealSeleccionado] = useState(null)
  const classes = useStyles()

  const renderCalificaciones = () => {
    if (!cerealSeleccionado) {
      return [<option value={null} key={0}>Seleccione primero un cereal</option>]
    }

    const options = calificaciones && calificaciones.map((calificacion) => {
    /** Se puede pedir una calificacion determinada, CONFORME no entra en estas opciones
    *  las cantidades se calculan diferenciando las que son silo aparte y las que no,
    *  descontando los pedidos pendientes en ambos casos.
    */

      const cantidadBase = isSiloAparte ? calificacion.cantidadSiloAparte : (calificacion.cantidad - calificacion.cantidadSiloAparte)
      const pedidosBase = isSiloAparte ? calificacion.pedidosPendientesSiloAparte : (calificacion.pedidosPendientes - calificacion.pedidosPendientesSiloAparte)
      const cantidad = cantidadBase - pedidosBase
      if (calificacion.label !== 'Conforme' && cantidad > 0 && calificacion.cereal === cerealSeleccionado.fieldName) {
        return (
          <option
            value={calificacion.fieldName}
            key={calificacion.fieldName}
          >
            {calificacion.label.toLocaleUpperCase()} ({calificacion.cantidad})
          </option>
        )
      }
      return null
    })
    options.unshift((<option value={null} key={0}>Seleccionar condición</option>))
    return options
  }

  const handleSelectCalificacion = (e, newValue) => {
    const cal = calificaciones.find(c => c.fieldName === newValue)
    setCalificacionSeleccionada(cal)
  }

  const handleSelectCereal = (e, newValue) => {
    const cer = cerealesActivos.find(c => c.fieldName === newValue)
    setCerealSeleccionado(cer)
  }

  const handleSiloAparte = () => {
    formChange('siloAparte', !isSiloAparte)
    setIsSiloAparte(!isSiloAparte)
    setCalificacionSeleccionada(null)
    props.cleanCalificacion()
  }

  let maxCamiones = null
  const limiteCalle = max

  if (calificacionSeleccionada) {
    maxCamiones = Math.min(calificacionSeleccionada.cantidad, limiteCalle)
  } else if (cerealSeleccionado) {
    maxCamiones = Math.min(cerealSeleccionado.cantidad, limiteCalle)
  }

  const valorMaximo = maxCamiones || limiteCalle || 0

  return (
    <Row className={classes.container}>
      <Col
        md={6}
        style={{
          justifyContent: 'flex-start',
          flexDirection: 'column',
          alignItems: 'flex-start',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px'
        }}
      >
        {/* Selección de cereales disponibles en playa de calado */}
        <p style={{ marginLeft: '8px', marginBottom: 0 }}>Seleccionar cereal *</p>
        <Field
          name='cerealPedido'
          className='radio-field'
          label='Cereal *'
          options={cerealesActivos}
          onChange={handleSelectCereal}
          component={(fieldProps) => (
            renderRadioField({
              ...fieldProps,
              wrapperStyle: { margin: 0, padding: 0, minHeight: 'auto', marginBottom: 0 }
            })
          )}
        />

        {/* Detalle de cantidades disponibles del cereal seleccionado */}
        {cerealSeleccionado && !calificacionSeleccionada && !isSiloAparte &&
          <EstadoCerealParaPedido cerealSeleccionado={cerealSeleccionado} />
        }
        { cerealSeleccionado && isSiloAparte &&
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <span>
                     Cantidad disponible "silo aparte" del cereal seleccionado:
          </span>
          <span style={{ fontWeight: 600 }}>
            <span style={{ color: COLORES.violet }}>
              {cerealSeleccionado.cantidadSiloAparteAutorizado || 0} (autorizados)</span> - {cerealSeleccionado.cantidadSiloAparte || 0} (pendientes en playa)
          </span>
        </Row>
        }
      </Col>

      <Col md={3} className={classes.contenidoCenter}>
        <CallesDeBruto />
      </Col>

      <Col md={3} style={{ margin: 'auto' }}>
        <Field
          name='cantidadPedido'
          type='number'
          label='Cantidad *'
          component={renderTextField}
          autoFocus={false}
          placeholder=''
          style={{ marginBottom: 0 }}
          max={valorMaximo}
          min={1}
        />
        { max && max >= 0 &&
          <>
            <small>Espacio disponible en calle: <b>{max}</b></small>
            <Tooltip title={'Se restan los pedidos pendientes'}>
              <IconButton>
                <InfoIcon fontSize='small' color='primary' />
              </IconButton>
            </Tooltip>
          </>
        }
      </Col>

      <Col md={6} style={{ marginTop: '2%' }}>
        <p style={{ marginLeft: '8px', marginBottom: 0 }}>Seleccionar condicion (opcional)</p>
        <Field
          name='calificacionCereal'
          placeholder='Calificación cereal'
          component={renderSelectField}
          onChange={handleSelectCalificacion}
          style={{ marginTop: '-2%' }}
        >
          { renderCalificaciones() }
        </Field>
        { calificacionSeleccionada &&
          <small style={{ color: COLORES.primary, fontWeight: 'bold' }}>
            Camiones <b>autorizados</b> disponibles con esta condición: {calificacionSeleccionada.cantidadAutorizada} - ({calificacionSeleccionada.cantidad} total )
          </small>
        }
      </Col>

      <Col md={3} className={classes.contenidoCenter}>
        <FormControlLabel
          control={
            <Switch
              color='primary'
              name='siloAparte'
              onChange={handleSiloAparte}
              checked={isSiloAparte}
            />
          }
          label='Silo aparte'
        />
      </Col>
      <Col md={3} className={classes.contenidoCenter} style={{ justifyContent: 'flex-end' }}>
        <Button
          variant='contained'
          onClick={handleSubmit}
          // disabled={disabled}
          style={{ backgroundColor: COLORES.grey.dark, color: 'white', width: '100%' }}
        >
          Crear pedido
        </Button>
      </Col>
      <Col md={12} style={{ textAlign: 'rigth', marginTop: '8px' }}>
        <p>(*) Campo requerido obligatorio</p>
      </Col>
    </Row>
  )
}

export default CamposPedidoCamiones
